// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Users_container__-XFtt {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  font-size: 16px;
}

.Users_container__-XFtt .Users_header__eh-4L {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.Users_container__-XFtt .Users_header__eh-4L .Users_titleContainer__qsdOT {
  animation: Users_init__SWT0D 0.3s 0.3s both;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.Users_container__-XFtt .Users_header__eh-4L .Users_titleContainer__qsdOT h4 {
  font-size: 1.6rem;
  font-family: Roboto, sans-serif;
  font-weight: 300;
}

.Users_filterButton__ZsymJ {
  animation: Users_init3__Sb91O 0.5s both;
  height: 3rem;
  width: 10rem;
  margin-left: 5px;
  margin-bottom: 10px;
  border-radius: 5px;
}

.Users_filterButton__ZsymJ p {
  text-transform: capitalize;
  margin-left: 5px;
  font-weight: 400;
}

/*---Información---*/
.Users_container__-XFtt .Users_data__u29AS .Users_tableContainer__0YjrR {
  animation: Users_init2__Z\\+q6G 0.3s 0.3s both;
  border-radius: 5px;
  box-shadow: 0 0 15px -3px rgba(0, 0, 0, 0.268);
}

.Users_container__-XFtt .Users_data__u29AS .Users_tableContainer__0YjrR .Users_tableHeader__CexZv {
  font-size: 0.9rem;
  font-weight: 500;
}

.Users_container__-XFtt .Users_data__u29AS .Users_tableContainer__0YjrR .Users_iconbtn__IAeRN {
  transition: 0.3s;
}

.Users_container__-XFtt .Users_data__u29AS .Users_tableContainer__0YjrR .Users_iconbtn__IAeRN:hover {
  cursor: pointer;
  transition: 0.3s;
  scale: 1.1;
  filter: brightness(1.4);
}

.Users_container__-XFtt .Users_loader__zwq-X {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.8rem;
  font-weight: 300;
  height: 300px;
}

@keyframes Users_init__SWT0D {
  0% {
    opacity: 0;
    transform: translateX(-20px);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes Users_init2__Z\\+q6G {
  0% {
    opacity: 0;
    transform: translateX(20px);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Pages/Refactor User/Users.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,2CAA8B;EAC9B,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,uCAA0B;EAC1B,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,6CAA+B;EAC/B,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF","sourcesContent":[".container {\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  font-size: 16px;\n}\n\n.container .header {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.container .header .titleContainer {\n  animation: init 0.3s 0.3s both;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.container .header .titleContainer h4 {\n  font-size: 1.6rem;\n  font-family: Roboto, sans-serif;\n  font-weight: 300;\n}\n\n.filterButton {\n  animation: init3 0.5s both;\n  height: 3rem;\n  width: 10rem;\n  margin-left: 5px;\n  margin-bottom: 10px;\n  border-radius: 5px;\n}\n\n.filterButton p {\n  text-transform: capitalize;\n  margin-left: 5px;\n  font-weight: 400;\n}\n\n/*---Información---*/\n.container .data .tableContainer {\n  animation: init2 0.3s 0.3s both;\n  border-radius: 5px;\n  box-shadow: 0 0 15px -3px rgba(0, 0, 0, 0.268);\n}\n\n.container .data .tableContainer .tableHeader {\n  font-size: 0.9rem;\n  font-weight: 500;\n}\n\n.container .data .tableContainer .iconbtn {\n  transition: 0.3s;\n}\n\n.container .data .tableContainer .iconbtn:hover {\n  cursor: pointer;\n  transition: 0.3s;\n  scale: 1.1;\n  filter: brightness(1.4);\n}\n\n.container .loader {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 1.8rem;\n  font-weight: 300;\n  height: 300px;\n}\n\n@keyframes init {\n  0% {\n    opacity: 0;\n    transform: translateX(-20px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n@keyframes init2 {\n  0% {\n    opacity: 0;\n    transform: translateX(20px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Users_container__-XFtt`,
	"header": `Users_header__eh-4L`,
	"titleContainer": `Users_titleContainer__qsdOT`,
	"init": `Users_init__SWT0D`,
	"filterButton": `Users_filterButton__ZsymJ`,
	"init3": `Users_init3__Sb91O`,
	"data": `Users_data__u29AS`,
	"tableContainer": `Users_tableContainer__0YjrR`,
	"init2": `Users_init2__Z+q6G`,
	"tableHeader": `Users_tableHeader__CexZv`,
	"iconbtn": `Users_iconbtn__IAeRN`,
	"loader": `Users_loader__zwq-X`
};
export default ___CSS_LOADER_EXPORT___;
